/*****************************************************************
 *  Viewer internationalization
 * ***************************************************************/

/**
 * Provide Locale
 * @returns string
 */
export const locale = () => {
    let locale = (navigator.languages !== undefined) ? navigator.languages[0].split('-')[0] : navigator.language.split('-')[0]
    return ['en', 'fr', 'es', 'pt', 'ja', 'it', 'zh'].includes(locale) ? locale : 'en'
}

/**
 * Provide viewer dictionary
 */
export const ihm_viewer__dictionary = {
    VIEWER:{
        en: '3D viewer',
        fr: 'Viewer 3D',
        es: 'Visor 3D',
        pt: 'Visualizador 3D',
        ja: '3Dビューア',
        it: 'Visualizzatore 3D',
        zh: '3D 查看器'
    },
    VIEW_MODE:{
        en: 'View',
        fr: 'Affichage',
        es: 'Ver',
        pt: 'Ver',
        ja: '見る',
        it: 'Vista',
        zh: '视图'
    },
    SINGLE_MODE:{
        en: 'Single',
        fr: 'Unique',
        es: 'Soltero',
        pt: 'Solteiro',
        ja: '単独',
        it: 'Singolo',
        zh: '单身的'
    },
    MULTIPLE_MODE:{
        en: 'Multiple',
        fr: 'Multiples',
        es: 'Múltiple',
        pt: 'Múltiplo',
        ja: '多数',
        it: 'Multiplo',
        zh: '多'
    },
    DOUBLE_MODE:{
        en: 'Double',
        fr: 'Double',
        es: 'Doble',
        pt: 'Duplo',
        ja: 'ダブル',
        it: 'Doppio',
        zh: '双'
    },
    TRIPLE_MODE:{
        en: 'Triple',
        fr: 'Triple',
        es: 'Triple',
        pt: 'Triplo',
        ja: 'トリプル',
        it: 'Triplo',
        zh: '三'
    },
    COMPARATIVE_VIEW:{
        en: 'Comparative View',
        fr: 'Vue comparative',
        es: 'Vista comparativa',
        pt: 'Visão comparativa',
        ja: '比較ビュー',
        it: 'Vista comparativa',
        zh: '比较视图'
    },
    VERSION_MODE:{
        en: 'Version',
        fr: 'Version',
        es: 'Versión',
        pt: 'Versão',
        ja: 'バージョン',
        it: 'Versione',
        zh: '版本'
    },
    CHANGE_MODE:{
        en: 'Mode',
        fr: 'Mode',
        es: 'Modo',
        pt: 'Modo',
        ja: 'モード',
        it: 'Modalità',
        zh: '模式'
    },
    VISUALIZATION_MODE : {
        en: 'Visualization',
        fr: 'Visualisation',
        es: 'Visualización',
        pt: 'Visualização',
        ja: '可視化',
        it: 'Visualizzazione',
        zh: '可视化'
    },
    EDITION_MODE : {
        en: 'Edition',
        fr: 'Edition',
        es: 'Edición',
        pt: 'Edição',
        ja: '編集',
        it: 'Edizione',
        zh: '版'
    },
    EDITOR_MODE_ACTIVE: {
        en: 'You are in Editor mode',
        fr: 'Vous êtes en mode édition',
        es: 'Estás en modo edición',
        pt: 'Você está no modo de edição',
        ja: '編集モードです',
        it: 'Sei in modalità modifica',
        zh: '您处于编辑模式'
    },
    ORIGINAL_VERSION:{
        en: 'Original',
        fr: 'Original',
        es: 'Original',
        pt: 'Original',
        ja: 'オリジナル',
        it: 'Originale',
        zh: '原版'
    },
    EDIT_VERSION:{
        'en': 'Edit selected version',
        'fr': 'Editer la version sélectionnée',
        'es': 'Editar la versión seleccionada',
        'pt': 'Editar a versão selecionada',
        'ja': '選択したバージョンを編集',
        'it': 'Modifica la versione selezionata',
        'zh': '编辑所选版本'
    },
    SAVE_VERSION:{
        'en' : 'Save a new version from modifications',
        'fr' : 'Enregistrer une nouvelle version à partir des modifications',
        'es' : 'Guardar una nueva versión a partir de las modificaciones',
        'pt' : 'Salvar uma nova versão das modificações',
        'ja' : '変更から新しいバージョンを保存',
        'it' : 'Salva una nuova versione dalle modifiche',
        'zh' : '保存新版本的修改'
    },
    CANCEL_VERSION:{
        'en' : 'Cancel modifications',
        'fr' : 'Annuler les modifications',
        'es' : 'Cancelar las modificaciones',
        'pt' : 'Cancelar as modificações',
        'ja' : '変更をキャンセル',
        'it' : 'Annulla le modifiche',
        'zh' : '取消修改'
    },
    CONFIRM_CANCEL_CHANGES:{
        'en' : 'Do you want to cancel the changes made on this version ?',
        'fr' : 'Voulez-vous annuler les modifications effectuées sur cette version ?',
        'es' : '¿Desea cancelar los cambios realizados en esta versión?',
        'pt' : 'Deseja cancelar as alterações feitas nesta versão?',
        'ja' : 'このバージョンで行った変更をキャンセルしますか？',
        'it' : 'Vuoi annullare le modifiche apportate a questa versione?',
        'zh' : '您要取消对此版本所做的更改吗？'
    },
    CONFIRM_DELETE_VERSION: {
        'en': 'Are you sure you want to delete this version?',
        'fr': 'Êtes-vous sûr de vouloir supprimer cette version ?',
        'es': '¿Está seguro de que desea eliminar esta versión?',
        'pt': 'Tem certeza de que deseja excluir esta versão?',
        'ja': 'このバージョンを削除してもよろしいですか？',
        'it': 'Sei sicuro di voler eliminare questa versione?',
        'zh': '您确定要删除此版本吗？'
    },
    VERSION_LABEL:{
        en: 'Version',
        fr: 'Version',
        es: 'Versión',
        pt: 'Versão',
        ja: 'バージョン',
        it: 'Versione',
        zh: '版本'
    },
    PATIENT:{
        en: 'Patient',
        fr: 'Patient',
        es: 'Paciente',
        pt: 'Paciente',
        ja: '患者',
        it: 'Paziente',
        zh: '病人'
    },
    CASE_ID:{
        en: 'Case ID',
        fr: 'Numéro',
        es: 'Número',
        pt: 'Número',
        ja: 'ケースID',
        it: 'Numero',
        zh: '数字'
    },
    STEPOF:{
        en: 'Step of',
        fr: 'Etape sur',
        es: 'Paso de',
        pt: 'Passo de',
        ja: 'ステップ',
        it: 'Passo di',
        zh: '步'
    },
    DATE:{
        en: 'Date',
        fr: 'Date',
        es: 'Date',
        pt: 'Date',
        ja: 'Date',
        it: 'Date',
        zh: 'Date'
    },
    MY_DASHBOARD:{
        en: 'My dashboard',
        fr: 'Mon tableau de bord',
        es: 'Mi tablero',
        pt: 'Meu painel',
        ja: 'ダッシュボード',
        it: 'La mia scrivania',
        zh: '我的仪表板'
    },
    ACCOUNT:{
        en: 'Account',
        fr: 'Compte',
        es: 'Cuenta',
        pt: 'Conta',
        ja: 'アカウント',
        it: 'Conto',
        zh: '帐户'
    },
    ACCOUNT_USERNAME:{
        en: 'Username',
        fr: 'Nom d\'utilisateur',
        es: 'Nombre de usuario',
        pt: 'Nome de usuário',
        ja: 'ユーザー名',
        it: 'Nome utente',
        zh: '用户名'
    },
    ACCOUNT_PASSWORD:{
        en: 'Password',
        fr: 'Mot de passe',
        es: 'Contraseña',
        pt: 'Senha',
        ja: 'パスワード',
        it: 'Password',
        zh: '密码'
    },
    ACCOUNT_NAME:{
        en: 'Name',
        fr: 'Nom',
        es: 'Apellido',
        pt: 'Nome',
        ja: '名前',
        it: 'Nome',
        zh: '姓名'
    },
    ACCOUNT_EMAIL:{
        en: 'Email',
        fr: 'Email',
        es: 'Email',
        pt: 'Email',
        ja: 'Eメール',
        it: 'E-mail',
        zh: '电子邮件'
    },
    ACCOUNT_MOBILE:{
        en: 'Mobile',
        fr: 'Portable',
        es: 'Teléfono móvil',
        pt: 'Celular',
        ja: '携帯電話',
        it: 'Cellulare',
        zh: '手机'
    },
    ACCOUNT_THIRD_PARTY_ACCOUNT:{
        en: 'Linked accounts',
        fr: 'Comptes liés',
        es: 'Cuenta de terceros',
        pt: 'Conta de terceiros',
        ja: 'リンクされたアカウント',
        it: 'Conto di terzi',
        zh: '第三方账户'
    },
    ACCOUNT_TYPE:{
        en: 'Type',
        fr: 'Type',
        es: 'Tipo',
        pt: 'Tipo',
        ja: 'タイプ',
        it: 'Tipo',
        zh: '类型'
    },
    ACCOUNT_NEXT_CHARGE:{
        en: 'Next charge',
        fr: 'Prochain prélèvement',
        es: 'Próxima recarga',
        pt: 'Próxima recarga',
        ja: '次回引き落とし',
        it: 'Prossima ricarica',
        zh: '下次充电'
    },
    ACCOUNT_LAST_INVOICE:{
        en: 'Last invoice',
        fr: 'Dernière facture',
        es: 'Última factura',
        pt: 'Última fatura',
        ja: '直近の請求書',
        it: 'Ultima fattura',
        zh: '最后一张发票'
    },
    ACCOUNT_MY_ID:{
        en: 'My id',
        fr: 'Mon identifiant',
        es: 'Mi identificador',
        pt: 'Meu identificador',
        ja: '私のID',
        it: 'Il mio identificatore',
        zh: '我的身份'
    },
    ACCOUNT_REFERRED_BY:{
        en: 'Referred by',
        fr: 'Référencé par',
        es: 'Referido por',
        pt: 'Referido por',
        ja: '参照元',
        it: 'Riferito da',
        zh: '由......推荐'
    },
    ACCOUNT_STORAGE:{
        en: 'Data storage',
        fr: 'Stockage de données',
        es: 'Almacenamiento de datos',
        pt: 'Armazenamento de dados',
        ja: 'ストレージ',
        it: 'Archivio dati',
        zh: '数据存储'
    },
    ACCOUNT_EXTRACT:{
        en: 'Export all my data',
        fr: 'Exporter toutes mes données',
        es: 'Exportar todos mis datos',
        pt: 'Exportar todos os meus dados',
        ja: 'すべてのデータをエクスポートする',
        it: 'Esporta tutti i miei dati',
        zh: '提炼'
    },
    ACCOUNT_DISCONNECT_ACTION:{
        en: 'DISCONNECT',
        fr: 'DECONNECTER',
        es: 'DESCONECTAR',
        pt: 'DESCONECTAR',
        ja: '切断',
        it: 'DISCONNETTI',
        zh: '断开'
    },
    ACCOUNT_MODIFY_ACTION:{
        en: 'MODIFY',
        fr: 'MODIFIER',
        es: 'MODIFICAR',
        pt: 'MODIFICAR',
        ja: '変更',
        it: 'MODIFICA',
        zh: '调整'
    },
    ACCOUNT_THIRD_PARTY_ACTION:{
        en: 'THIRD-PARTY',
        fr: 'ASSOCIER',
        es: 'TERCERA PARTE',
        pt: 'TERCEIRA PARTE',
        ja: '第三者',
        it: 'TERZA PARTE',
        zh: '第三方'
    },
    ACCOUNT_UPGRADE_ACTION:{
        en: 'UPGRADE',
        fr: 'MODIFIER',
        es: 'MEJORAR',
        pt: 'MELHORAR',
        ja: 'アップグレード',
        it: 'AGGIORNA',
        zh: '升级'
    },
    ACCOUNT_CANCEL_ACTION:{
        en: 'CANCEL',
        fr: 'ANNULER',
        es: 'CANCELAR',
        pt: 'CANCELAR',
        ja: 'キャンセル',
        it: 'ANNULLA',
        zh: '取消'
    },
    ACCOUNT_CHANGE_ACTION:{
        en: 'CHANGE',
        fr: 'MODIFIER',
        es: 'CAMBIAR',
        pt: 'MUDAR',
        ja: '変更',
        it: 'MODIFICA',
        zh: '改变'
    },
    SPE_CURRENT:{
        en: 'CURRENT',
        fr: 'ACTUEL',
        es: 'ACTUAL',
        pt: 'ATUAL',
        ja: '現在',
        it: 'ATTUALE',
        zh: '当前的'
    },
    SPE_TOTAL:{
        en: 'TOTAL',
        fr: 'TOTAL',
        es: 'TOTAL',
        pt: 'TOTAL',
        ja: '合計',
        it: 'TOTALE',
        zh: '全部的'
    },
    SPE_MAXI:{
        en: 'Maxillary',
        fr: 'Maxillaire',
        es: 'maxilar',
        pt: 'maxillary',
        ja: '上顎',
        it: 'mascellare',
        zh: '上颌'
    },
    SPE_MAXI_SHORT:{
        en: 'Maxi.',
        fr: 'Maxi.',
        es: 'Maxi.',
        pt: 'Maxi.',
        ja: 'Maxi.',
        it: 'Maxi.',
        zh: 'Maxi.'
    },
    SPE_MAND:{
        en: 'Mandibular',
        fr: 'Mandibulaire',
        es: 'mandibular',
        pt: 'mandibular',
        ja: '下顎',
        it: 'mandibolare',
        zh: '下颌'
    },
    SPE_MAND_SHORT:{
        en: 'Mand.',
        fr: 'Mand.',
        es: 'Mand.',
        pt: 'Mand.',
        ja: 'Mand.',
        it: 'Mand.',
        zh: 'Mand.'
    },
    SPE_MOVEMENTS:{
        en: 'MOVEMENTS',
        fr: 'MOUVEMENTS',
        es: 'MOVIMIENTOS',
        pt: 'MOVIMENTOS',
        ja: '動き',
        it: 'MOVIMENTI',
        zh: '机芯 '
    },
    SPE_MODEL:{
        en: 'MODEL',
        fr: 'MODÈLE',
        es: 'MODELO',
        pt: 'MODELO',
        ja: 'モデル',
        it: 'MODELLO',
        zh: '模型'
    },
    //
    SECTION_MEASURES:{
        en: 'Measures',
        fr: 'Mesures',
        es: 'Medidas',
        pt: 'Medidas',
        ja: '測定',
        it: 'Misure',
        zh: '措施'
    },
    SECTION_ANALYSIS:{
        en: 'Analysis',
        fr: 'Analyses',
        es: 'Análisis',
        pt: 'Análise',
        ja: '分析',
        it: 'Analisi',
        zh: '分析'
    },
    SPE_MOVEMENTS_ITEMS:{
        DISTALMESIAL: {
            en: 'Mesial/Distal Trans(mm)',
            fr: 'Mesio-distal Trans(mm)',
            es: 'Mesio-distal Trans(mm)',
            pt: 'Mesio-distal Trans(mm)',
            ja: '近心/遠位の移動(mm)',
            it: 'Mesio-distal Trans(mm)',
            zh: 'Mesio-distal Trans(mm)'
        },
        DISTALMESIAL_SHORT: {
            en: 'MD Trans(mm)',
            fr: 'MD Trans(mm)',
            es: 'MD Trans(mm)',
            pt: 'MD Trans(mm)',
            ja: 'MD Trans(mm)',
            it: 'MD Trans(mm)',
            zh: 'MD Trans(mm)'
        },
        TORQUE: {
            en: 'Buccal/Lingual Inc(°)',
            fr: 'Bucco-Lingual Inc(°)',
            es: 'Bucco-Lingual Inc(°)',
            pt: 'Bucco-Lingual Inc(°)',
            ja: '頬側/舌側の傾き(°)',
            it: 'Bucco-Lingual Inc(°)',
            zh: 'Bucco-Lingual Inc(°)'
        },
        TORQUE_SHORT: {
            en: 'BL Inc(°)',
            fr: 'BL Inc(°)',
            es: 'BL Inc(°)',
            pt: 'BL Inc(°)',
            ja: 'BL Inc(°)',
            it: 'BL Inc(°)',
            zh: 'BL Inc(°)'
        },
        ROTATION: {
            en: 'Rotation(°)',
            fr: 'Rotation(°)',
            es: 'Rotación(°)',
            pt: 'Rotação(°)',
            ja: '回転(°)',
            it: 'Rotazione(°)',
            zh: '回转(°)'
        },
        ROTATION_SHORT: {
            en: 'Rot(°)',
            fr: 'Rot(°)',
            es: 'Rot(°)',
            pt: 'Rot(°)',
            ja: 'Rot(°)',
            it: 'Rot(°)',
            zh: 'Rot(°)'
        },
        LINGUALVESTIBULAR: {
            en: 'Buccal/Lingual Trans(mm)',
            fr: 'Bucco-Lingual Trans(mm)',
            es: 'Bucco-Lingual Trans(mm)',
            pt: 'Bucco-Lingual Trans(mm)',
            ja: '頬側/舌側の移動(mm)',
            it: 'Bucco-Lingual Trans(mm)',
            zh: 'Bucco-Lingual Trans(mm)'
        },
        LINGUALVESTIBULAR_SHORT: {
            en: 'BL Trans(mm)',
            fr: 'BL Trans(mm)',
            es: 'BL Trans(mm)',
            pt: 'BL Trans(mm)',
            ja: 'BL Trans(mm)',
            it: 'BL Trans(mm)',
            zh: 'BL Trans(mm)'
        },
        TIP: {
            en: 'Mesial/distal Ang(°)',
            fr: 'Mesio-distal Ang(°)',
            es: 'Mesio-distal Ang(°)',
            pt: 'Mesio-distal Ang(°)',
            ja: '近心/遠心の傾き(°)',
            it: 'Mesio-distal Ang(°)',
            zh: 'Mesio-distal Ang(°)'
        },
        TIP_SHORT: {
            en: 'MD Ang(°)',
            fr: 'MD Ang(°)',
            es: 'MD Ang(°)',
            pt: 'MD Ang(°)',
            ja: 'MD Ang(°)',
            it: 'MD Ang(°)',
            zh: 'MD Ang(°)'
        },
        EXTRUSIONINTRUSION: {
            en: 'Intrusion/Extrusion(mm)',
            fr: 'Ingression-Egression(mm)',
            es: 'Intrusion/Extrusion(mm)',
            pt: 'Intrusion/Extrusion(mm)',
            ja: '陥入/挺出(mm)',
            it: 'Intrusion/Extrusion(mm)',
            zh: 'Intrusion/Extrusion(mm)'
        },
        EXTRUSIONINTRUSION_SHORT: {
            en: 'Int/Ext(mm)',
            fr: 'Int/Ext(mm)',
            es: 'Int/Ext(mm)',
            pt: 'Int/Ext(mm)',
            ja: 'Int/Ext(mm)',
            it: 'Int/Ext(mm)',
            zh: 'Int/Ext(mm)'
        }
    },
    SPE_IPR_ATT:{
        en: 'IPR/ATT',
        fr: 'IPR/ATT',
        es: 'IPR/ATT',
        pt: 'IPR/ATT',
        ja: 'IPR/アタッチメント',
        it: 'IPR/ATT',
        zh: 'IPR/ATT'
    },
    SPE_IPR_ATT_ITEM:{
        MESIAL: {
            en: 'Mesial(mm)',
            fr: 'Mésial(mm)',
            es: 'Mesial(mm)',
            pt: 'Mesial(mm)',
            ja: '近心(mm)',
            it: 'Mesial(mm)',
            zh: 'Mesial(mm)'
        },
        DISTAL: {
            en: 'Distal(mm)',
            fr: 'Distal(mm)',
            es: 'Distal(mm)',
            pt: 'Distal(mm)',
            ja: '遠心(mm)',
            it: 'Distal(mm)',
            zh: 'Distal(mm)'
        },
        ATTACHMENTPOS: {
            en: 'Attachment+',
            fr: 'Taquets+',
            es: 'adjunto+',
            pt: 'acessório+',
            ja: 'アタッチメント＋',
            it: 'allegato+',
            zh: '依恋+'
        },
        ATTACHMENTNEG: {
            en: 'Attachment-',
            fr: 'Taquets-',
            es: 'adjunto-',
            pt: 'acessório-',
            ja: 'アタッチメント－',
            it: 'allegato-',
            zh: '依恋-'
        },
        BUTTON: {
            en: 'Buttons',
            fr: 'Boutons',
            es: 'botones',
            pt: 'botões',
            ja: 'ボタン',
            it: 'pulsanti',
            zh: '纽扣'
        },
    },
    SPE_BITEJUMP:{
        en: 'BITEJUMP',
        fr: 'BITEJUMP',
        es: 'BITEJUMP',
        pt: 'BITEJUMP',
        ja: 'BITEJUMP',
        it: 'BITEJUMP ',
        zh: 'BITEJUMP'
    },
    SPE_MEASURES:{
        en: 'MEASURES ',
        fr: 'MESURES',
        es: 'MEDIDAS',
        pt: 'MEDIDAS',
        ja: '測定',
        it: 'MISURE',
        zh: '措施'
    },
    SPE_MOVEMENT_HISTORY:{
        en: 'HISTORY',
        fr: 'HISTORIQUE',
        es: 'HISTORIAL',
        pt: 'HISTÓRICO',
        ja: '履歴',
        it: 'STORICO',
        zh: '历史'
    },
    SPE_NOTE:{
        en: 'NOTE',
        fr: 'NOTE',
        es: 'NOTA',
        pt: 'NOTA',
        ja: 'メモ',
        it: 'NOTA',
        zh: '笔记'
    },
    MOVEMENT_HISTORY:{
        en: 'Movement History',
        fr: 'Historique des mouvements',
        es: 'Historial de movimientos',
        pt: 'Histórico de movimentos',
        ja: '動きの履歴',
        it: 'Storico movimenti',
        zh: '移动历史'
    },
    CURRENT:{
        en: 'Current',
        fr: 'Actuelle',
        es: 'Actual',
        pt: 'Atual',
        ja: '現在',
        it: 'Attuale',
        zh: '当前'
    },
    FROM_VERSION:{
        en: 'From version',
        fr: 'De la version',
        es: 'De la version',
        pt: 'Da versao',
        ja: 'バージョンから',
        it: 'Dalla versione',
        zh: '来自版本'
    },
    NO_MOVEMENT_HISTORY:{
        en: 'No movement history for this version.',
        fr: 'Aucun historique de mouvement pour cette version.',
        es: 'Sin historial de movimientos para esta version.',
        pt: 'Sem historico de movimentos para esta versao.',
        ja: 'このバージョンには移動履歴がありません。',
        it: 'Nessuno storico movimenti per questa versione.',
        zh: '此版本没有移动历史。'
    },
    SPE_MEASURES_ITEMS:{
        ARCH_WIDTH:{
            en: 'Arch width ',
            fr: 'Largeur arcade',
            es: 'Arch width',
            pt: 'Arch width',
            ja: 'アーチ幅',
            it: 'Arch width ',
            zh: 'Arch width'
        },
        MAIN_MEASURES:{
            en: 'Main measures',
            fr: 'Principales mesures',
            es: 'Medidas principales',
            pt: 'Medidas principais',
            ja: '主な測定',
            it: 'Misure principali',
            zh: '主要测量'
        },
        BOLTON_ANALYSIS:{
            en: 'Bolton analysis',
            fr: 'Analyse de Bolton',
            es: 'Análisis de Bolton',
            pt: 'Análise de Bolton',
            ja: 'ボルトン分析',
            it: 'Analisi di Bolton',
            zh: 'Bolton 分析'
        },
        KORKHAUS_ANALYSIS:{
            en: 'Korkhaus analysis',
            fr: 'Analyse de Korkhaus',
            es: 'Análisis de Korkhaus',
            pt: 'Análise de Korkhaus',
            ja: 'コークハウス分析',
            it: 'Analisi di Korkhaus',
            zh: 'Korkhaus 分析'
        },
        U_MEASURES:{
            en: 'Upp.Meas',
            fr: 'Mesures Maxi.',
            es: 'U.Measures',
            pt: 'U.Measures',
            ja: '上顎測定',
            it: 'U.Measures ',
            zh: 'U.Measures'
        },
        L_MEASURES:{
            en: 'Low.Meas',
            fr: 'Mesures Mand.',
            es: 'L.Measures',
            pt: 'L.Measures',
            ja: '下顎測定',
            it: 'L.Measures ',
            zh: 'L.Measures'
        },
        KVAL:{
            en: 'K.val',
            fr: 'Val.k',
            es: 'K.val',
            pt: 'K.val',
            ja: 'K値',
            it: 'K.val ',
            zh: 'K.val'
        },
        DIFF:{
            en: 'Diff',
            fr: 'Diff',
            es: 'Diff',
            pt: 'Diff',
            ja: 'Diff',
            it: 'Diff ',
            zh: 'Diff'
        },
        VALUE:{
            en: 'Value',
            fr: 'Valeur',
            es: 'Value',
            pt: 'Value',
            ja: '値',
            it: 'Value ',
            zh: 'Value'
        },
        RATIO:{
            en: 'Ratio',
            fr: 'Ratio',
            es: 'Ratio',
            pt: 'Ratio',
            ja: '比率',
            it: 'Ratio ',
            zh: 'Ratio'
        },
        EXCESS33:{
            en: 'Mand Excess 3-3',
            fr: 'Excès Mand 3-3',
            es: 'Mand Excess 3-3',
            pt: 'Mand Excess 3-3',
            ja: '過蓋咬合3-3',
            it: 'Mand Excess 3-3',
            zh: 'Mand Excess 3-3'
        },
        EXCESS66:{
            en: 'Mand Excess 6-6',
            fr: 'Excès Mand 6-6',
            es: 'Mand Excess 6-6',
            pt: 'Mand Excess 6-6',
            ja: '過蓋咬合6-6',
            it: 'Mand Excess 6-6',
            zh: 'Mand Excess 6-6'
        },
        UPPER:{
            en: 'Upper',
            fr: 'Maxi',
            es: 'Upper',
            pt: 'Upper',
            ja: '上顎',
            it: 'Upper ',
            zh: 'Upper'
        },
        LOWER:{
            en: 'Lower',
            fr: 'Mandi',
            es: 'Lower',
            pt: 'Lower',
            ja: '下顎',
            it: 'Lower ',
            zh: 'Lower'
        },
        L:{
            en: 'Arch Length (L)',
            fr: 'Long Arcade (L)',
            es: 'Arch Length (L)',
            pt: 'Arch Length (L)',
            ja: 'アーチ長 (L)',
            it: 'Arch Length (L)',
            zh: 'Arch Length (L)'
        },
        LC:{
            en: 'Canine spacing (Lc)',
            fr: 'Distance Canines (Lc)',
            es: 'Canine spacing (Lc)',
            pt: 'Canine spacing (Lc)',
            ja: '犬歯幅(Lc)',
            it: 'Canine spacing (Lc)',
            zh: 'Canine spacing (Lc)'
        },
        LM:{
            en: 'Molar spacing (Lm)',
            fr: 'Distance Molaires (Lm)',
            es: 'Molar spacing (Lm)',
            pt: 'Molar spacing (Lm)',
            ja: '臼歯幅 (Lm)',
            it: 'Molar spacing (Lm)',
            zh: 'Molar spacing (Lm)'
        },
        ARCHPERIMETER:{
            en: 'Arch perimeter',
            fr: 'Périmetre Arcade',
            es: 'Arch perimeter',
            pt: 'Arch perimeter',
            ja: 'アーチの周囲',
            it: 'Arch perimeter',
            zh: 'Arch perimeter'
        },
        SUM33:{
            en: 'Sum3-3',
            fr: 'Som.3-3',
            es: 'Sum3-3',
            pt: 'Sum3-3',
            ja: '3-3の合計',
            it: 'Sum3-3',
            zh: 'Sum3-3'
        },
        SUM66:{
            en: 'Sum6-6',
            fr: 'Som.6-6',
            es: 'Sum6-6',
            pt: 'Sum6-6',
            ja: '6-6の合計',
            it: 'Sum6-6',
            zh: 'Sum6-6'
        },
        A:{
            en: 'Interpremolars dist (A)',
            fr: 'Distance Prémolaires(A)',
            es: 'Interpremolars dist (A)',
            pt: 'Interpremolars dist (A)',
            ja: '歯列弓幅径 (A)',
            it: 'Interpremolars dist (A)',
            zh: 'Interpremolars dist (A)'
        },
        B:{
            en: 'Intermolars dist (B)',
            fr: 'Distance Molaires (B)',
            es: 'Intermolars dist (B)',
            pt: 'Intermolars dist (B)',
            ja: '歯列弓幅径 (B)',
            it: 'Intermolars dist (B)',
            zh: 'Intermolars dist (B)'
        },
        C:{
            en: 'Incisors to (A)',
            fr: 'Distance Incisives-(A)',
            es: 'Incisors to (A)',
            pt: 'Incisors to (A)',
            ja: '歯列弓長径（A）',
            it: 'Incisors to (A)',
            zh: 'Incisors to (A)'
        },
    },
    POST_SECTOR: {
        en: 'Posterior sector',
        fr: 'Secteur postérieur',
        es: 'Sector posterior',
        pt: 'Setor posterior',
        ja: '後部セクター',
        it: 'Settore posteriore',
        zh: '后部'
    },
    ANT_SECTOR: {
        en: 'Anterior sector',
        fr: 'Secteur antérieur',
        es: 'Sector anterior',
        pt: 'Setor anterior',
        ja: '前のセクター',
        it: 'Settore precedente',
        zh: '上一個行業'
    },
    404: {
        en: {
            title: 'Project not found',
            content: 'File is not available on the platform anymore \nContact your partner'
        },
        fr: {
            title: 'Projet non trouvé',
            content: 'Le fichier n\'est plus disponible sur la plateforme \nContactez votre partenaire'
        },
        es: {
            title: 'Proyecto no encontrado',
            content: 'Archivo ya no está a disposición \nContacte con su proveedor'
        },
        pt: {
            title: 'Project not found',
            content: 'Arquivo não estiver mais disponível \nContacte o seu fornecedor'
        },
        ja: {
            title: 'プロジェクトが見つかりません',
            content: 'プラットフォームでファイルを使用できなくなりました 販売元に連絡してください'
        },
        it: {
            title: 'Project not found',
            content: 'File is not available on the platform anymore \nContact your supplier'
        },
        zh: {
            title: 'Project not found',
            content: 'File is not available on the platform anymore \nContact your supplier'
        }
    },
    LANDSCAPE_ALERT: {
        en: 'Please use your device in landscape mode',
        fr: 'Veuillez utiliser votre appareil en mode paysage',
        es: 'Por favor, use su dispositivo en modo horizontal',
        pt: 'Por favor, use seu dispositivo no modo paisagem',
        ja: '端末を横向きでご使用ください',
        it: 'Si prega di utilizzare il dispositivo in modalità orizzontale',
        zh: '请将设备切换为横屏模式使用'
    },
    VALIDATION:{
        HEADER_LINE: {
                en: 'This case has been sent by:',
                fr: 'Ce cas vous est envoyé par :',
                es: 'Este caso ha sido enviado por:',
                pt: 'Este caso foi enviado por:',
                ja: 'この症例は次の方から送信されました：',
                it: 'Questo caso è stato inviato da:',
                zh: '该病例由以下人员发送：'
        },
        ACTION:{
            CONSULT:{
                en: 'Consult',
                fr: 'Consulter',
                es: 'Consultar',
                pt: 'Consultar',
                ja: '患者の症例を参照してください',
                it: 'Consulta',
                zh: '咨询患者案例'
            },
            VALIDATE:{
                en: 'Validate',
                fr: 'Valider',
                es: 'Validar',
                pt: 'Validar',
                ja: '患者の症例を検証する',
                it: 'Convalida',
                zh: '验证患者案例'
            },
            REFUSE:{
                en: 'Refuse',
                fr: 'Refuser',
                es: 'Denegar',
                pt: 'Recusar',
                ja: '患者のケースを拒否する',
                it: 'Rifiuta',
                zh: '拒绝病人案例'
            }
        },
        TRAITMENT_PLAN:{
            en: 'Treatment plan',
            fr: 'Le plan de traitement',
            es: 'El plan de tratamiento',
            pt: 'O plano de tratamento',
            ja: '治療計画',
            it: 'Piano di trattamento',
            zh: '治疗计划'
        },
        LAST_ACTION: {
            en: 'Last action on case',
            fr: 'Dernière action sur le cas',
            es: 'Última acción sobre el caso',
            pt: 'Última ação no caso',
            ja: '症例の最終アクション',
            it: 'Ultima azione sul caso',
            zh: '病例的最后操作'
        },
        STATUSES:{
            PENDING:{
                en: 'Pending',
                fr: 'En attente',
                es: 'Pendiente',
                pt: 'Pendente',
                ja: '保留中',
                it: 'In attesa',
                zh: '待定'
            },
            CONSULTED:{
                en: 'Reviewed',
                fr: 'Consulté',
                es: 'Consultado',
                pt: 'Consultado',
                ja: '確認済み',
                it: 'Recensito',
                zh: '已审核'
            },
            IN_PROGRESS:{
                en: 'In progress',
                fr: 'En cours',
                es: 'En progreso',
                pt: 'Em progresso',
                ja: '進行中',
                it: 'In corso',
                zh: '进行中'
            },
            VALIDATED:{
                en: 'Validated',
                fr: 'Validé',
                es: 'Validado',
                pt: 'Validado',
                ja: '検証済み',
                it: 'Convalidato',
                zh: '已验证'
            },
            REFUSED:{
                en: 'Refused',
                fr: 'Refusé',
                es: 'Denegado',
                pt: 'Recusado',
                ja: '拒否されました',
                it: 'Rifiutato',
                zh: '已拒绝'
            },
            CLOSED:{
                en: 'Closed',
                fr: 'Terminé',
                es: 'Cerrado',
                pt: 'Fechado',
                ja: '閉まった',
                it: 'Chiuso',
                zh: '关闭'
            }
        },
        RECIPIENT:{
            en: 'Recipient',
            fr: 'Destinataire',
            es: 'Destinatario',
            pt: 'Destinatário',
            ja: '受取人',
            it: 'Destinatario',
            zh: '收件人'
        },
        CASE_ID:{
            en: 'CASE_ID',
            fr: 'ID DU CAS',
            es: 'IDENTIFICACIÓN DEL CASO',
            pt: 'IDENTIFICAÇÃO DO CASO',
            ja: 'ケースID',
            it: 'CASE_ID',
            zh: '案例ID'
        },
        DELIVERY_DATE:{
            en: 'DELIVERY DATE',
            fr: 'DATE DE LIVRAISON',
            es: 'ENTREGA',
            pt: 'ENTREGA',
            ja: '配達',
            it: 'CONSEGNA',
            zh: '送货'
        },
        NO_REPLY_DISCLAMER:{
            en: 'Do not reply directly to this sender.',
            fr: 'Ne pas repondre directement à cet expéditeur.',
            es: 'No responda directamente a este remitente.',
            pt: 'Não responda diretamente a este remetente.',
            ja: 'この送信者に直接返信しないでください。',
            it: 'Non rispondere direttamente a questo mittente.',
            zh: '不要直接回复此发件人。'
        }
    },
    LOGIN: {
        LOGIN_TITLE:{
            en: 'Login Account',
            fr: 'Connectez vous',
            es: 'Acceso',
            pt: 'Conecte-se',
            ja: 'ログイン',
            it: 'Login',
            zh: '登录'
        },
        EMAIL_ADDRESS:{
            en: 'E-mail address',
            fr: 'Adresse e-mail',
            es: 'Dirección de correo electrónico',
            pt: 'Endereço de e-mail',
            ja: 'メールアドレス',
            it: 'Indirizzo e-mail',
            zh: '电子邮件地址'
        },
        PASSWORD:{
            en: 'Password',
            fr: 'Mot de passe',
            es: 'Contraseña',
            pt: 'Senha',
            ja: 'パスワード',
            it: 'Password',
            zh: '密码'
        },
        SHOW:{
            en: 'Show',
            fr: 'Afficher',
            es: 'Mostrar',
            pt: 'Mostrar',
            ja: '表示',
            it: 'Mostra',
            zh: '显示'
        },
        ASK_FORGOTTEN_PASSWORD:{
            en: 'Forgot your password?',
            fr: 'Mot de passe oublié ?',
            es: '¿Has olvidado tu contraseña?',
            pt: 'Esqueceu sua senha?',
            ja: 'パスワードをお忘れですか？',
            it: 'Hai dimenticato la password?',
            zh: '忘记密码？'
        },
        LOGIN:{
            en: 'Login',
            fr: 'Connexion',
            es: 'Acceso',
            pt: 'Conecte-se',
            ja: 'ログイン',
            it: 'Accedere',
            zh: '登录'
        },
        LOGOUT:{
            en: 'Logout',
            fr: 'Déconnexion',
            es: 'Cerrar sesión',
            pt: 'Sair',
            ja: 'ログアウト',
            it: 'Disconnettersi',
            zh: '登出'
        },
        REMEMBERME:{
            en: 'Remember me',
            fr: 'Se souvenir de moi',
            es: 'Recuérdame',
            pt: 'Lembre de mim',
            ja: 'ログイン状態を保存',
            it: 'Ricordami',
            zh: '记住我'
        },
        ASK_FIRST_VISITE:{
            en: 'First visit ?',
            fr: 'Première visite ?',
            es: '¿Primera visita?',
            pt: 'Primeira visita?',
            ja: '初めての訪問ですか？',
            it: 'Prima visita?',
            zh: '首次访问？'
        },
        CREATE_ACCOUNT:{
            en: 'Create an account.',
            fr: 'Créer un compte.',
            es: 'Crea una cuenta.',
            pt: 'Crie uma conta.',
            ja: 'アカウントを作成する。',
            it: 'Crea un account.',
            zh: '创建一个帐户。'
        },
        MESSAGE:{
            OK:{
                en: 'Successful authentication',
                fr: 'Authentification réussie',
                es: 'Autenticación exitosa',
                pt: 'Autenticação bem-sucedida',
                ja: '認証成功',
                it: 'Autenticazione riuscita',
                zh: '认证成功'
            },
            ERROR:{
                en: 'Authentication failed',
                fr: 'Authentification échouée',
                es: 'Autenticación fallida',
                pt: 'Falha na autenticação',
                ja: '認証に失敗しました',
                it: 'Autenticazione fallita',
                zh: '身份验证失败'
            }
        }
    },
    FICHIERS:{
        en: 'FILES',
        fr: 'FICHIERS',
        es: 'ARCHIVOS',
        pt: 'ARQUIVOS',
        ja: 'ファイル',
        it: 'FILES',
        zh: '文件'
    },
    CHAT:{
        en: 'CHAT',
        fr: 'MESSAGERIE',
        es: 'MENSAGERIA',
        pt: 'MENSAGENS',
        ja: 'メッセージング',
        it: 'MESSAGGISTICA',
        zh: '消息传递'
    },
    LOGINMSG:{
        MAILSENT:{
            en: 'Mail sent',
            fr: 'Mail envoyé',
            es: 'Correo enviado',
            pt: 'Email enviado',
            ja: 'メール送信済み',
            it: 'Email inviata',
            zh: '邮件已发送'
        },
        INACTIVEACCOUNT:{
            en: 'Account not Active',
            fr: 'Compte inactif',
            es: 'Cuenta no activa',
            pt: 'Conta inativa',
            ja: 'アカウントがアクティブではありません',
            it: 'Account non attivo',
            zh: '账号未激活'
        },
        NOTEXISTINGACCOUNT:{
            en: 'Account does not exists',
            fr: 'Compte inexistant',
            es: 'La cuenta no existe',
            pt: 'A conta não existe',
            ja: 'アカウントが存在しません',
            it: 'L\'account non esiste',
            zh: '账户不存在'
        },
        UNKNOWNERROR:{
            en: 'Unknown Error',
            fr: 'Erreur non reconnue',
            es: 'Error desconocido',
            pt: 'Erro desconhecido',
            ja: '不明なエラー',
            it: 'Errore sconosciuto',
            zh: '未知错误'
        },
        TYPEEMAIL:{
            en: 'Type your email',
            fr: 'Saisissez votre email',
            es: 'Escriba su correo electrónico',
            pt: 'Digite seu e-mail',
            ja: 'メールアドレスを入力してください',
            it: 'Digita la tua email',
            zh: '输入您的电子邮件'
        },
        CONNECTIONERROR:{
            en: 'Connection Error',
            fr: 'Erreur de Connexion',
            es: 'Error de conexión',
            pt: 'Erro de conexão',
            ja: '接続エラー',
            it: 'Errore di connessione',
            zh: '连接错误'
        },
        WRONGCREDENTIALS:{
            en: 'Wrong Credentials',
            fr: 'Identifiants incorrects',
            es: 'Credenciales incorrectas',
            pt: 'Credenciais incorretas',
            ja: '誤った資格情報',
            it: 'Credenziali errate',
            zh: '凭据错误'
        },
        TOOMANYATTEMPTS: {
            en: 'Too many failed login attempts. Please try again later.',
            fr: 'Trop de tentatives de connexion échouées. Veuillez réessayer plus tard.',
            es: 'Demasiados intentos de inicio de sesión fallidos. Por favor, inténtelo de nuevo más tarde.',
            pt: 'Muitas tentativas de login falhadas. Por favor, tente novamente mais tarde.',
            ja: 'ログイン試行回数が多すぎます。後でもう一度お試しください。',
            it: 'Troppi tentativi di accesso falliti. Per favore riprova più tardi.',
            zh: '登录尝试失败次数过多。请稍后再试。'
        },
        INVALIDEMAIL: {
            en: 'Invalid email address',
            fr: 'Adresse email invalide',
            es: 'Dirección de correo electrónico no válida',
            pt: 'Endereço de e-mail inválido',
            ja: '無効なメールアドレス',
            it: 'Indirizzo email non valido',
            zh: '无效的电子邮件地址'
        },
        NETWORKERROR: {
            en: 'Network error. Please try again.',
            fr: 'Erreur réseau. Veuillez réessayer.',
            es: 'Error de red. Por favor, inténtelo de nuevo.',
            pt: 'Erro de rede. Por favor, tente novamente.',
            ja: 'ネットワークエラー。もう一度お試しください。',
            it: 'Errore di rete. Per favore riprova.',
            zh: '网络错误。请重试。'
        },
        SERVERERROR: {
            en: 'Server error. Please try again later.',
            fr: 'Erreur serveur. Veuillez réessayer plus tard.',
            es: 'Error del servidor. Por favor, inténtelo de nuevo más tarde.',
            pt: 'Erro do servidor. Por favor, tente novamente mais tarde.',
            ja: 'サーバーエラー。後でもう一度お試しください。',
            it: 'Errore del server. Per favore riprova più tardi.',
            zh: '服务器错误。请稍后再试。'
        },
        ATTEMPTSREMAINING: {
            en: 'attempt remaining',
            fr: 'tentative restante',
            es: 'intento restante',
            pt: 'tentativa restante',
            ja: '残りの試行',
            it: 'tentativo rimanente',
            zh: '剩余尝试'
        },
        ATTEMPTSREMAININGPLURAL: {
            en: 'attempts remaining',
            fr: 'tentatives restantes',
            es: 'intentos restantes',
            pt: 'tentativas restantes',
            ja: '残りの試行',
            it: 'tentativi rimanenti',
            zh: '剩余尝试'
        }
    },
    COLLISION_COMPUTING:{
        en: 'Collision computing ...',
        fr: 'Calcul des collisions ...',
        es: 'Colisión de cálculo ...',
        pt: 'Colisão de cálculo ...',
        ja: '衝突計算...',
        it: 'Collisione di calcolo ...',
        zh: '碰撞计算...'
    },
    SAVING:{
        en: 'Saving ...',
        fr: 'Sauvegarde en cours ...',
        es: 'Guardando ...',
        pt: 'Salvando ...',
        ja: '保存中...',
        it: 'Salvataggio ...',
        zh: '保存中...'
    },
    DELETING:{
        en: 'Deleting ...',
        fr: 'Suppression en cours ...',
        es: 'Eliminando ...',
        pt: 'Excluindo ...',
        ja: '削除中...',
        it: 'Eliminazione ...',
        zh: '删除中...'
    },
    YES:{
        en: 'Yes',
        fr: 'Oui',
        es: 'Si',
        pt: 'Sim',
        ja: 'はい',
        it: 'Sì',
        zh: '是'
    },
    NO:{
        en: 'No',
        fr: 'Non',
        es: 'No',
        pt: 'Não',
        ja: 'いいえ',
        it: 'No',
        zh: '不'
    },
    VIEW_ARCH_CONTACTS:{
        en: 'View arch contacts',
        fr: 'Voir contacts arc',
        pt: 'Ver contatos arco',
        ja: 'アーチコンタクトを表示',
        it: 'Visualizza contatti ad arco',
        zh: '查看弓接触'
    },
    HIDE_ARCH_CONTACTS:{
        en: 'Hide arch contacts',
        fr: 'Cacher contacts arc',
        pt: 'Ocultar contatos arco',
        ja: 'アーチコンタクトを非表示',
        it: 'Nascondi contatti ad arco',
        zh: '隐藏弓接触'
    },
    VIEW_TOOTH_CONTACTS:{
        en: 'View tooth contacts',
        fr: 'Voir contacts',
        pt: 'Ver contatos',
        ja: '歯の接触を表示',
        it: 'Visualizza contatti',
        zh: '查看牙齿接触'
    },
    HIDE_TOOTH_CONTACTS:{
        en: 'Hide tooth contacts',
        fr: 'Cacher les contacts',
        pt: 'Ocultar contatos',
        ja: '歯の接触を非表示',
        it: 'Nascondi contatti',
        zh: '隐藏牙齿接触'
    },
    SETTINGS:{
        en: 'Settings',
        fr: 'Paramètres',
        es: 'Configuraciones',
        pt: 'Configurações',
        ja: '設定',
        it: 'Impostazioni',
        zh: '设置'
    },
    VALIDATE:{
        en: 'Validate',
        fr: 'Valider',
        es: 'Validar',
        pt: 'Validar',
        ja: '検証',
        it: 'Convalida',
        zh: '验证'
    },
    DISPLAY_STRIPPING:{
        en: 'Contact',
        fr: 'Contact',
        es: 'Contacto',
        pt: 'Contato',
        ja: 'コンタクト',
        it: 'Contatto',
        zh: '接触'
    },
    HIDE_STRIPPING:{
        en: 'Contact',
        fr: 'Contact',
        es: 'Contacto',
        pt: 'Contato',
        ja: 'コンタクト',
        it: 'Contatto',
        zh: '接触'
    },    
    DISPLAY_INTERFERENCE:{
        en: 'Occ. Map',
        fr: 'Occ. Map',
        es: 'Occ. Map',
        pt: 'Occ. Map',
        ja: 'Occ. Map',
        it: 'Occ. Map',
        zh: 'Occ. Map'
    },
    HIDE_INTERFERENCE:{
        en: 'Occ. Map',
        fr: 'Occ. Map',
        es: 'Occ. Map',
        pt: 'Occ. Map',
        ja: 'Occ. Map',
        it: 'Occ. Map',
        zh: 'Occ. Map'
    },
    HELP_BTN:{
        PDF_TXT:{
            en: 'User manual',
            fr: 'Manuel utilisateur',
            es: 'Manual de usuario',
            pt: 'Manual do usuário',
            ja: 'ユーザーマニュアル',
            it: 'Manuale utente',
            zh: '用户手册'
        },
        PDF_LINK:{
            en: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Interface%20utilisateur_EN.pdf',
            fr: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Interface%20utilisateur_FR.pdf',
            es: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Interface%20utilisateur_EN.pdf',
            pt: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Interface%20utilisateur_EN.pdf',
            ja: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Interface%20utilisateur_EN.pdf',
            it: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Interface%20utilisateur_EN.pdf',
            zh: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Interface%20utilisateur_EN.pdf'
        },
        VIDEO_TXT:{
            en: 'Video tutorials',
            fr: 'Tutoriels vidéo',
            es: 'Video tutoriales',
            pt: 'Vídeo tutoriais',
            ja: 'ビデオチュートリアル',
            it: 'Video tutorial',
            zh: '视频教程'
        },
        VIDEO_LINK:{
            en: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Tutorial_EN.mp4',
            fr: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Tutorial_FR.mp4',
            es: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Tutorial_EN.mp4',
            pt: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Tutorial_EN.mp4',
            ja: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Tutorial_EN.mp4',
            it: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Tutorial_EN.mp4',
            zh: 'http://exchanges.c4w-ftp.com/Smile.webEditor/Tutorial_EN.mp4'
        }
    },
    SECTION_BITEJUMP:{
        en: 'BiteJump',
        fr: 'BiteJump',
        es: 'BiteJump',
        pt: 'BiteJump',
        ja: 'BiteJump',
        it: 'BiteJump',
        zh: 'BiteJump',
    },
    BITEJUMP_X:{
        en: 'Sagittal',
        fr: 'Sagittal',
        es: 'Sagittal',
        pt: 'Sagittal',
        ja: 'Sagittal',
        it: 'Sagittal',
        zh: 'Sagittal',
    },
    BITEJUMP_Y:{
        en: 'Frontal',
        fr: 'Frontal',
        es: 'Frontal',
        pt: 'Frontal',
        ja: 'Frontal',
        it: 'Frontal',
        zh: 'Frontal',
    },
    BITEJUMP_Z:{
        en: 'Occlusal',
        fr: 'Occlusal',
        es: 'Occlusal',
        pt: 'Occlusal',
        ja: 'Occlusal',
        it: 'Occlusal',
        zh: 'Occlusal',
    },
    INIT_PHASES: {
        STORE_READY: {
            en: 'Initializing project',
            fr: 'Initialisation du projet',
            es: 'Inicializando proyecto',
            pt: 'Inicializando projeto',
            ja: 'プロジェクトを初期化中',
            it: 'Inizializzazione del progetto',
            zh: '正在初始化项目'
        },
        PROJECT_FETCHING: {
            en: 'Fetching project data',
            fr: 'Récupération des données',
            es: 'Recuperando datos del proyecto',
            pt: 'Buscando dados do projeto',
            ja: 'プロジェクトデータを取得中',
            it: 'Recupero dei dati del progetto',
            zh: '正在获取项目数据'
        },
        PROJECT_DOWNLOADING: {
            en: 'Downloading assets',
            fr: 'Téléchargement des ressources',
            es: 'Descargando recursos',
            pt: 'Baixando recursos',
            ja: 'リソースをダウンロード中',
            it: 'Download delle risorse',
            zh: '正在下载资源'
        },
        PROJECT_STORING: {
            en: 'Saving project',
            fr: 'Sauvegarde du projet',
            es: 'Guardando el proyecto',
            pt: 'Salvando projeto',
            ja: 'プロジェクトを保存中',
            it: 'Salvataggio del progetto',
            zh: '正在保存项目'
        },
        SCENE_CREATED: {
            en: 'Building scene',
            fr: 'Création de la scène',
            es: 'Creando la escena',
            pt: 'Criando a cena',
            ja: 'シーンを構築中',
            it: 'Creazione della scena',
            zh: '正在构建场景'
        },
        MODELS_LOADED: {
            en: 'Loading 3D models',
            fr: 'Chargement des modèles 3D',
            es: 'Cargando modelos 3D',
            pt: 'Carregando modelos 3D',
            ja: '3Dモデルを読み込み中',
            it: 'Caricamento dei modelli 3D',
            zh: '正在加载3D模型'
        },
        ANIMATION_READY: {
            en: 'Setting up lighting',
            fr: "Configuration de l’éclairage",
            es: 'Configurando la iluminación',
            pt: 'Configurando iluminação',
            ja: '照明を設定中',
            it: "Configurazione dell'illuminazione",
            zh: '正在设置光照'
        },
        COMPARATIVE_READY: {
            en: 'Preparing tools',
            fr: 'Préparation des outils',
            es: 'Preparando herramientas',
            pt: 'Preparando ferramentas',
            ja: 'ツールを準備中',
            it: 'Preparazione degli strumenti',
            zh: '正在准备工具'
        },
        UI_READY: {
            en: 'Finalizing interface',
            fr: 'Finalisation de l’interface',
            es: 'Finalizando la interfaz',
            pt: 'Finalizando a interface',
            ja: 'インターフェースを最終調整中',
            it: 'Finalizzazione dell’interfaccia',
            zh: '正在完成界面'
        },
        COMPLETE: {
            en: 'Ready',
            fr: 'Prêt',
            es: 'Listo',
            pt: 'Pronto',
            ja: '準備完了',
            it: 'Pronto',
            zh: '已完成'
        }
    },
    MAINTENANCE: {
        TITLE: {
            en: 'Scheduled maintenance',
            fr: 'Maintenance planifiée',
            es: 'Mantenimiento programado',
            pt: 'Manutenção programada',
            ja: '予定されたメンテナンス',
            it: 'Manutenzione programmata',
            zh: '计划维护'
        },
        CONTINUE: {
            en: 'Continue',
            fr: 'Continuer',
            es: 'Continuar',
            pt: 'Continuar',
            ja: '次へ',
            it: 'Continua',
            zh: '继续'
        },
        DONT_SHOW_AGAIN: {
            en: 'Do not show again',
            fr: 'Ne plus afficher',
            es: 'No volver a mostrar',
            pt: 'Não mostrar novamente',
            ja: '今後表示しない',
            it: 'Non mostrare più',
            zh: '不再显示'
        },
        MESSAGE: {
            en: 'Maintenance is scheduled from {start} to {end} ({timezone}). Some features may be temporarily unavailable.',
            fr: 'Une maintenance est planifiée du {start} au {end} ({timezone}). Certaines fonctionnalités peuvent être temporairement indisponibles.',
            es: 'Hay un mantenimiento planificado desde {start} hasta {end} ({timezone}). Algunas funcionalidades pueden estar temporalmente no disponibles.',
            pt: 'Uma manutenção está programada de {start} a {end} ({timezone}). Alguns recursos podem estar temporariamente indisponíveis.',
            ja: 'メンテナンスは {start} から {end}（{timezone}）まで予定されています。一部の機能が一時的に利用できない場合があります。',
            it: 'È prevista una manutenzione da {start} a {end} ({timezone}). Alcune funzionalità potrebbero essere temporaneamente non disponibili.',
            zh: '维护计划安排在 {start} 至 {end}（{timezone}）。某些功能可能暂时不可用。'
        }
    },
    NOTIFICATIONS: {
        en: 'Notifications',
        fr: 'Notifications',
        es: 'Notificaciones',
        pt: 'Notificações',
        ja: '通知',
        it: 'Notifiche',
        zh: '通知'
    },
    NOTIFICATION_GUEST_TEXT: {
        en: 'Log in and enable notifications to stay informed about your cases (imports, new messages, etc.).',
        fr: 'Connectez-vous et activez les notifications pour être tenu au courant de tout ce qui se passe sur vos cas (importations, nouveaux messages, etc.).',
        es: 'Inicie sesión y active las notificaciones para mantenerse informado sobre sus casos (importaciones, mensajes nuevos, etc.).',
        pt: 'Faça login e ative as notificações para se manter informado sobre seus casos (importações, novas mensagens, etc.).',
        ja: 'ログインして通知を有効にし、ケース（インポート、新しいメッセージなど）に関する最新情報を入手してください。',
        it: 'Accedi e abilita le notifiche per rimanere informato sui tuoi casi (importazioni, nuovi messaggi, ecc.).',
        zh: '登录并启用通知以了解您的案例（导入、新消息等）。'
    },
    NOTIFICATION_GUEST_LINKED_1: {
        en: 'Notifications are enabled for ',
        fr: 'Les notifications sont activées pour ',
        es: 'Las notificaciones están habilitadas para ',
        pt: 'As notificações estão ativadas para ',
        ja: '通知が有効になっています ',
        it: 'Le notifiche sono abilitate per ',
        zh: '已启用通知 '
    },
    NOTIFICATION_GUEST_LINKED_2: {
        en: '. Log in to view your ',
        fr: '. Connectez-vous pour consulter vos ',
        es: '. Inicie sesión para ver sus ',
        pt: '. Faça login para visualizar suas ',
        ja: '。ログインして確認してください ',
        it: '. Accedi per visualizzare le tue ',
        zh: '。登录以查看您的 '
    },
    NOTIFICATION_GUEST_LINKED_3: {
        en: ' pending notification(s).',
        fr: ' notification(s) en attente.',
        es: ' notificación(es) pendiente(s).',
        pt: ' notificação(ões) pendente(s).',
        ja: ' 件の保留中の通知。',
        it: ' notifica(he) in attesa.',
        zh: ' 条未决通知。'
    },
    NOTIFICATION_PROMO: {
        en: 'Enable notifications to stay informed about activity on your cases.',
        fr: 'Activez les notifications pour rester informé de l\'activité sur vos cas.',
        es: 'Active las notificaciones para mantenerse informado sobre la actividad en sus casos.',
        pt: 'Ative as notificações para se manter informado sobre a atividade em seus casos.',
        ja: '通知を有効にして、ケースのアクティビティに関する情報を入手してください。',
        it: 'Attiva le notifiche per rimanere informato sull\'attività sui tuoi casi.',
        zh: '启用通知以随时了解您案例的活动。'
    },
    NOTIFICATION_BLOCKED: {
        en: 'Notifications are blocked. Allow them in your browser settings to be alerted.',
        fr: 'Les notifications sont bloquées. Autorisez-les dans les paramètres de votre navigateur pour être alerté.',
        es: 'Las notificaciones están bloqueadas. Permítalas en la configuración de su navegador para recibir alertas.',
        pt: 'As notificações estão bloqueadas. Permita-as nas configurações do seu navegador para ser alertado.',
        ja: '通知がブロックされています。警告を受けるにはブラウザの設定で許可してください。',
        it: 'Le notifiche sono bloccate. Consentile nelle impostazioni del tuo browser per essere avvisato.',
        zh: '通知被屏蔽。在浏览器设置中允许它们接收警报。'
    },
    ACTIVATE: {
        en: 'Enable',
        fr: 'Activer',
        es: 'Activar',
        pt: 'Ativar',
        ja: '有効にする',
        it: 'Attiva',
        zh: '使能够'
    },
    READ_ALL: {
        en: 'Read all',
        fr: 'Tout lire',
        es: 'Leer todo',
        pt: 'Ler tudo',
        ja: 'すべて既読にする',
        it: 'Leggi tutto',
        zh: '全读'
    },
    DELETE_ALL: {
        en: 'Delete all',
        fr: 'Tout supprimer',
        es: 'Eliminar todo',
        pt: 'Excluir tudo',
        ja: 'すべて削除',
        it: 'Elimina tutto',
        zh: '全部删除'
    },
    NO_NOTIFICATIONS: {
        en: 'No notifications',
        fr: 'Aucune notification',
        es: 'Sin notificaciones',
        pt: 'Sem notificações',
        ja: '通知なし',
        it: 'Nessuna notifica',
        zh: '没有通知'
    },
    PUSH_FILE_SENT: {
        en: 'Sent you a file',
        fr: 'Vous a envoyé un fichier',
        es: 'Le ha enviado un archivo',
        pt: 'Enviou-lhe um arquivo',
        ja: 'ファイルを送信しました',
        it: 'Ti ha inviato un file',
        zh: '给您发送了一个文件'
    },
    PUSH_MULTIPLE_FILES_SENT: {
        en: 'Sent you {{count}} files',
        fr: 'Vous a envoyé {{count}} fichiers',
        es: 'Le ha enviado {{count}} archivos',
        pt: 'Enviou-lhe {{count}} arquivos',
        ja: '{{count}} 個 of ファイルを送信しました',
        it: 'Ti ha inviato {{count}} file',
        zh: '给您发送了 {{count}} 个文件'
    },
    PUSH_CASE_GENERATED: {
        en: 'A new case has been generated',
        fr: 'Un nouveau cas a été généré',
        es: 'Se ha generado un nuevo caso',
        pt: 'Um novo caso foi gerado',
        ja: '新しい症例が生成されました',
        it: 'È stato generato un nuovo caso',
        zh: '已生成一个新病例'
    },
    PUSH_NEW_MESSAGE: {
        en: 'Sent you a new message',
        fr: 'Vous a envoyé un nouveau message',
        es: 'Le ha enviado un nuevo mensaje',
        pt: 'Enviou-lhe uma nova mensagem',
        ja: '新しいメッセージを送信しました',
        it: 'Ti ha inviato un nuovo messaggio',
        zh: '给您发送了一条新消息'
    },
    PUSH_MULTIPLE_MESSAGES: {
        en: 'Sent you {{count}} new messages',
        fr: 'Vous a envoyé {{count}} nouveaux messages',
        es: 'Le ha enviado {{count}} nuevos mensajes',
        pt: 'Enviou-lhe {{count}} novas mensagens',
        ja: '{{count}} 件の新しいメッセージを送信しました',
        it: 'Ti ha inviato {{count}} nuovi messaggi',
        zh: '给您发送了 {{count}} 条新消息'
    },
    PUSH_NEW_VERSION: {
        en: 'A new version has been published',
        fr: 'Une nouvelle version a été publiée',
        es: 'Se ha publicado una nueva versión',
        pt: 'Uma nova versão foi publicada',
        ja: '新しいバージョンが公開されました',
        it: 'È stata pubblicata una nuova versione',
        zh: '已发布新版本'
    },
    PUSH_SPECIFIC_VERSION: {
        en: 'Version {{version}} has been published',
        fr: 'La version {{version}} a été publiée',
        es: 'La versión {{version}} ha sido publicada',
        pt: 'A versão {{version}} foi publicada',
        ja: 'バージョン {{version}} が公開されました',
        it: 'La versione {{version}} è stata pubblicata',
        zh: '版本 {{version}} 已发布'
    },
    PUSH_CHAT_MESSAGE: {
        en: 'Message from {{sender}}',
        fr: 'Message de {{sender}}',
        es: 'Mensaje de {{sender}}',
        pt: 'Mensagem de {{sender}}',
        ja: '{{sender}} から의 メッセージ',
        it: 'Messaggio da {{sender}}',
        zh: '来自 {{sender}} 的消息'
    },
    PWA_INSTALL_TITLE: {
        en: 'Install Application',
        fr: "Installer l'application",
        es: 'Instalar la aplicación',
        pt: 'Instalar o aplicativo',
        ja: 'アプリをインストール',
        it: 'Installa applicazione',
        zh: '安装应用'
    },
    PWA_INSTALL_IOS_TEXT: {
        en: 'A mobile-friendly version is available! To install it, tap the Share icon, then "More", and select "Add to Home Screen".',
        fr: "Une version mobile adaptée est disponible ! Pour l'installer, appuyez sur l'icône Partager, puis sur \"Plus\", et enfin sur \"Sur l'écran d'accueil\".",
        es: '¡Está disponible una versión optimizada para móviles! Para instalarla, pulse el icono Compartir, luego "Más", y seleccione "Añadir a la pantalla de inicio".',
        pt: 'Uma versão otimizada para celular está disponível! Para instalá-la, toque no ícone Compartilhar, depois em "Mais" e selecione "Adicionar à tela inicial".',
        ja: 'モバイル最適化バージョンが利用可能です！インストールするには、共有アイコンをタップし、「その他」を選択してから「ホーム画面に追加」を選択してください。',
        it: 'È disponibile una versione ottimizzata per dispositivi mobili! Per installarla, tocca l\'icona Condividi, poi "Altro" e seleziona "Aggiungi alla schermata home".',
        zh: '移动端优化版本已就绪！要进行安装，请点击分享图标，然后点击“更多”，并选择“添加到主屏幕”。'
    },
    PWA_INSTALL_ANDROID_TEXT: {
        en: 'Add Smile.web to your home screen for faster access and a full-screen experience.',
        fr: "Ajoutez Smile.web à votre écran d'accueil pour y accéder plus rapidement et profiter d'une expérience plein écran.",
        es: 'Añada Smile.web a su pantalla de inicio para un acceso más rápido y una experiencia a pantalla completa.',
        pt: 'Adicione o Smile.web à sua tela inicial para acesso mais rápido e uma experiência em tela cheia.',
        ja: 'Smile.webをホーム画面に追加すると、より速くアクセスでき、全画面表示でご利用いただけます。',
        it: 'Aggiungi Smile.web alla schermata iniziale per un accesso più rapido e un\'esperienza a schermo intero.',
        zh: '将 Smile.web 添加到主屏幕以实现更快的访问和全屏体验。'
    },
    PWA_INSTALL_TOOLTIP: {
        en: 'Install Smile.web',
        fr: 'Installer Smile.web',
        es: 'Instalar Smile.web',
        pt: 'Instalar o Smile.web',
        ja: 'Smile.webをインストール',
        it: 'Installa Smile.web',
        zh: '安装 Smile.web'
    },
    PWA_INSTALL_LATER: {
        en: 'Later',
        fr: 'Plus tard',
        es: 'Más tarde',
        pt: 'Mais tarde',
        ja: '後で',
        it: 'Più tardi',
        zh: '稍后'
    },
    PWA_INSTALL_NOW: {
        en: 'Install',
        fr: 'Installer',
        es: 'Instalar',
        pt: 'Instalar',
        ja: 'インストール',
        it: 'Installa',
        zh: '安装'
    }
}

/**
 * Index local web browser
 */

const local__dictionary = {
    en: 'en-US',
    fr: 'fr-FR',
    es: 'es-ES',
    pt: 'pt-br',
    ja: 'ja-JP',
    it: 'it-IT',
    zh: 'zh-CN'
}


/**
 * Provide converted format date
 * @returns string
 */
export const get_current_date = (date = null) => {
    date = date ?? new Date()
    return new Intl.DateTimeFormat(local__dictionary[locale()], { dateStyle: 'full', timeStyle: 'long' }).format(date)
}
